import useSmartQueryClient from "@/hooks/useSmartQueryClient";
import { signOut } from "aws-amplify/auth";

export default function useLogout() {
  const smartQueryClient = useSmartQueryClient();

  const logout = () => {
    smartQueryClient.invalidateQueries();
    signOut();
  };

  return { logout };
}
